module.exports = __webpack_public_path__ + "img/pc-vi.1d73a950.jpg";